import { useQuery } from '@tanstack/react-query';
import defaultFetch from 'react/api/sagas/fetch/defaultFetch';

async function getEventComments(eventLogId) {
  const criteria = '{"filters":["user.key","user.name","comment","noteTime"]}';
  const payload = {
    criteriaChain: [
      {
        and: [
          {
            attr: 'eventLog.id',
            eq: eventLogId
          }
        ]
      }
    ],
    sort: [{ attr: 'noteTime', type: 'ASC' }]
  };

  const url = `/EventLogNotes/restrictions?criteria=${encodeURI(criteria)}`;
  const response = await defaultFetch(url, payload, 'POST');

  if (response.error) {
    throw new Error('Failed fetch');
  }

  return response;
}

export function useEventComments(eventLogId) {
  return useQuery({
    queryKey: ['event-comments', eventLogId],
    staleTime: 1000 * 60 * 60 * 24 * 7, // 1 week
    queryFn: async () => getEventComments(eventLogId)
  });
}
